export default __webpack_public_path__ + "static/media/negative.cb317ee5.svg";